import request from '@/utils/request'
import host from '@/api/base/host'
import { AsyncRequest } from '@/utils/request'
const apiUrl = host.path('dev', { module: 'activity', dev: 'v1/activity' })
const apiUrl2 = host.path('dev', { module: 'activity', dev: 'v2/activity' })
const apiUrl1 = host.path('dev', { module: 'activity', dev: 'v1' })

export default {
  // 活动概览
  activityDetail(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('overview'),
          method: 'post',
          data
        })
    })
  },
  //推荐码
  activityRecommend(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('recommendCode'),
          method: 'post',
          data
        })
    })
  },
  //输入推荐码跳转
  activityRecommendJump(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('share/recommendCode'),
          method: 'post',
          data
        })
    })
  },
  activityShare(data) {
    // return AsyncRequest({
    //   loading: true,
    //   request: () =>
    //     request({
    //       url: apiUrl('share'),
    //       method: 'post',
    //       data
    //     })
    // })
    return request({
      loading: true,
      url: apiUrl('share'),
      method: 'post',
      data
    })
  },
  activityProgress(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('process'),
          method: 'post',
          data
        })
    })
  },
  getAdviserDetail(params) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl1(`adviser/page/${params.configId}`),
          method: 'get'
          // params
        })
    })
  },
  activityCashInfo(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('cashInfo'),
          method: 'post',
          data
        })
    })
  },
  activityWithdrawal(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl2('h5/withdrawal'),
          method: 'post',
          data
        })
    })
  },
  withdrawalByBankSubmit(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl2('h5/withdrawalByBank'),
          method: 'post',
          data
        })
    })
  },
  withdrawalByBankCalcSubmit(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl2('h5/withdrawalByBankCalc'),
          method: 'post',
          data
        })
    })
  },
  // 申领活动
  shareActivityDetail(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('userApply/overview'),
          method: 'post',
          data
        })
    })
  },
  shareActivityVerify(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('userApply/validActivityAndReward'),
          method: 'post',
          data
        })
    })
  },
  shareActivitySubmit(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('userApply/examine'),
          method: 'post',
          data
        })
    })
  },

  isVipActivity(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl1('user/myinfo/vip/adviser'),
          method: 'post',
          data
        })
    })
  },

  updateAddress(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('userApply/updateAddress'),
          method: 'post',
          data
        })
    })
  },
  // 礼品卡转介绍活动
  giftCardActivityDetail(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('card/overview'),
          method: 'post',
          data
        })
    })
  },
  // 礼品卡领取
  giftCardJoin(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('card/join'),
          method: 'post',
          data
        })
    })
  },
  // 礼品卡进度
  giftCardProcess(data) {
    return AsyncRequest({
      loading: true,
      request: () =>
        request({
          url: apiUrl('card/process'),
          method: 'post',
          data
        })
    })
  }
}
